import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import privacyPDF from "./privacy.pdf";
import privacySpanishPDF from "./privacy-spanish.pdf";
import "react-pdf/dist/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function Privacy() {
  const [numPages, setNumPages] = useState(0);
  const [language, setLanguage] = useState("English");
  const [pdfFile, setPDFFile] = useState(privacyPDF);

  function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
    console.log(numPages);
    setNumPages(numPages);
  }

  return (
    <div className="App">
      <div className="lang-div">
        <select
          value={language}
          onChange={(e) => {
            if (e.target.value === "English") {
              setPDFFile(privacyPDF);
            } else {
              setPDFFile(privacySpanishPDF);
            }
            setLanguage(e.target.value);
          }}
          className="language-select"
        >
          <option value="English">English</option>
          <option value="Spanish">Spanish</option>
        </select>
      </div>
      <Document
        file={pdfFile}
        onLoadSuccess={onDocumentLoadSuccess}
        className="pdf-document"
      >
        {Array.from(new Array(numPages), (el, index) => (
          <Page key={`page_${index + 1}`} pageNumber={index + 1} />
        ))}
      </Document>
    </div>
  );
}

export default Privacy;
